export default "__VITE_ASSET__B09WEy9Q__"